import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CheckboxInput from 'packages/ui/CheckboxInput';
import FieldContainer from 'packages/ui/FieldContainer';
import { useEventCategories } from 'helpers/hooks/resource';

const CheckboxGroup = styled('div')`
  display: flex;
  flex-wrap: wrap;

  > * {
    margin-bottom: 5px;
    margin-left: 20px;
    width: 130px;
  }
`;

const Divider = styled('div')`
  background-color: #bdc3c7;
  display: ${props => (props.hidden ? 'none' : 'initial')};
  margin: 10px auto;
  height: 1px;
  width: 100%;
`;

function CategoriesInput({ extraOptions, onChange, value, type }) {
  const categories = useEventCategories();
  let selected = value && value.length > 0 ? value : [];
  let allCategories = categories.body.data.reduce((acc, current) => {
    const children = current.children.data.map(child => child);
    return [...acc, current, ...children];
  }, []);
  const options = [...allCategories, ...extraOptions];
  // type !== 'subscribers'
  //   ? [...categories.body.data, ...extraOptions]
  //   : [...allCategories, ...extraOptions];

  const childrenChecker = (arr, target) => target.every(v => arr.includes(v));
  return (
    <FieldContainer label="موضوعات موردنطر را انتخاب کنید">
      <CheckboxGroup>
        {options.map((category, index) => {
          let value = [category.id];
          let isSubCategory = category.parent_id !== 0;
          if (!isSubCategory) {
            const childrenIds = category.children.data.map(cat => cat.id);
            if (childrenChecker(selected, childrenIds)) {
              selected = [...selected, category.id];
            }
            value = [...value, ...category.children.data.map(cat => cat.id)];
          }

          return [
            <Divider key={`${category.id}-divider`} hidden={isSubCategory || index === 0} />,
            <CheckboxInput
              key={category.id}
              checked={selected.includes(category.id)}
              description={category.title}
              size={type !== 'subscribers' || isSubCategory ? 'small' : 'normal'}
              onChange={event => {
                onChange(
                  event.target.checked
                    ? [...selected, ...value]
                    : selected.filter(item => !value.includes(item))
                );
              }}
            />
          ];
        })}
        <Divider key={`all-divider`} hidden={false} />
        <CheckboxInput
          key="all"
          checked={selected.length === 0}
          description="همه"
          size="small"
          onChange={event => {
            onChange(event.target.checked ? [] : [...selected]);
          }}
        />
      </CheckboxGroup>
    </FieldContainer>
  );
}

CategoriesInput.propTypes = {
  extraOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired
    })
  )
};

CategoriesInput.defaultProps = {
  extraOptions: []
};

export default memo(CategoriesInput);
